import React from 'react';
import close from '../images/infographic1/sources-close.png';
import '../stylesheets/Sources.scss';

export default function Sources() {
  return (
    <section className="sources-container">
      <div
        className="sources-drawer"
        id="drawer"
        onClick={() => {
          let drawer = document.getElementById('drawer');
          if (drawer.style.display === 'flex') {
            drawer.style.display = 'none';
          } else {
            drawer.style.display = 'flex';
          }
        }}
      >
        <div className="close">
          <img src={close} alt="close" />
        </div>
        <div className="sources-list">
          <ol>
            <li>https://www.census.gov/newsroom/press-releases/2015/cb15-113.html</li>
            <li>https://dynamicsignal.com/2018/10/09/key-statistics-millennials-in-the-workplace/</li>
            <li>https://www.pewresearch.org/fact-tank/2018/03/01/millennials-overtake-baby-boomers/</li>
            <li> https://www.sage.com/na/~/media/site/sagena/responsive/docs/startup/report</li>
            <li> https://www.pewresearch.org/fact-tank/2019/07/24/baby-boomers-us-labor-force/</li>
            <li>https://www.urban.org/sites/default/files/publication/98729/2019_01_11_millennial_homeownership_finalizedv2.pdf</li>
            <li>https://www.rentcafe.com/blog/apartment-search-2/money/millennials-spend-93000-on-rent-by-the-time-they-hit-30/</li>
            <li>https://www.nar.realtor/sites/default/files/reports/2017/2017-real-estate-in-a-digital-age-03-10-2017.pdf</li>
            <li> https://rew-online.com/2016/03/survey-gen-x-workers-like-communal-spaces-living-in-the-suburbs/</li>
            <li> https://rew-online.com/2016/03/survey-gen-x-workers-like-communal-spaces-living-in-the-suburbs/</li>
            <li> https://www.cnbc.com/2019/09/29/millennials-are-fleeing-big-cities-for-the-suburbs.html</li>
            <li> https://bettermoneyhabits.bankofamerica.com/content/dam/bmh/pdf/ar6vnln9-boa-bmh-millennial-report-winter-2018-final2.pdf</li>
            <li> https://www.researchgate.net/figure/Optimal-length-of-employment-relations-with-one-organization-own-study_fig1_323014394</li>
            <li> https://www.marketingcharts.com/customer-centric/spending-trends-105985</li>
            <li> https://www.marketingcharts.com/customer-centric/spending-trends-105985</li>
            <li> https://www.cardrates.com/news/study-2-3-millennials-hate-credit-cards/</li>
            <li> https://www.mediapost.com/publications/article/284152/87-of-millennials-use-mobile-banking-security-st.html</li>
            <li> https://bettermoneyhabits.bankofamerica.com/content/dam/bmh/pdf/ar6vnln9-boa-bmh-millennial-report-winter-2018-final2.pdf</li>
            <li> https://bettermoneyhabits.bankofamerica.com/content/dam/bmh/pdf/ar6vnln9-boa-bmh-millennial-report-winter-2018-final2.pdf</li>
            <li> https://www.businessinsider.com/half-of-gen-x-has-no-retirement-savings-account-2019-10</li>
            <li> https://www.ivyinvestments.com/content/generational-happiness</li>
          </ol>
        </div>
      </div>
      <h3
        onClick={() => {
          let drawer = document.getElementById('drawer');
          if (drawer.style.display === 'flex') {
            drawer.style.display = 'none';
          } else {
            drawer.style.display = 'flex';
          }
        }}
      >
        View Sources
      </h3>
    </section>
  );
}
